export enum EResourceStatus {
  Available = 'Available',
  Assigned = 'Assigned',
  OnRest = 'OnRest',
}
